<template>
  <nav>
    <p>
      <span>{{ updateFilter.length }}</span> items left
    </p>
    <ul class="res-big">
      <li
        :class="{
          filterBy: filterBy === 'all',
          'dark-mode': mode === 'dark',
        }"
        @click="filterUpdate('all')"
      >
        All
      </li>
      <li
        :class="{
          filterBy: filterBy === 'active',
          'dark-mode': mode === 'dark',
        }"
        @click="filterUpdate('active')"
      >
        Active
      </li>
      <li
        :class="{
          filterBy: filterBy === 'complete',
          'dark-mode': mode === 'dark',
        }"
        @click="filterUpdate('complete')"
      >
        Completed
      </li>
    </ul>
    <p
      @click="delComp"
      :class="{ 'dark-mode': mode === 'dark' }"
      class="clear-complete"
    >
      Clear Completed
    </p>
  </nav>

  <ul class="res-small" :class="mode == 'dark' ? 'list-dark' : 'list-ligth'">
    <li
      :class="{
        filterBy: filterBy === 'all',
        'dark-mode': mode === 'dark',
      }"
      @click="filterUpdate('all')"
    >
      All
    </li>
    <li
      :class="{
        filterBy: filterBy === 'active',
        'dark-mode': mode === 'dark',
      }"
      @click="filterUpdate('active')"
    >
      Active
    </li>
    <li
      :class="{
        filterBy: filterBy === 'complete',
        'dark-mode': mode === 'dark',
      }"
      @click="filterUpdate('complete')"
    >
      Completed
    </li>
  </ul>
</template>

<script>
export default {
  emits: ["delComp", "filterUpdate"],
  props: ["projects", "filterBy", "updateFilter", "mode"],

  methods: {
    filterUpdate(event) {
      this.$emit("filterUpdate", event);
    },

    delComp() {
      this.projects.forEach((project) => {
        if (project.complete) {
          if (process.env.VUE_APP_URI) {
            fetch(`${process.env.VUE_APP_URI}${project.id}`, {
              method: "DELETE",
            })
              .then(() => {
                const item = this.projects.filter(
                  (project) => !project.complete
                );
                this.$emit("delComp", item);
              })
              .catch((e) => console.log(e));
          }

          const item = this.projects.filter((project) => !project.complete);
          this.$emit("delComp", item);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem 2.4rem;
  font-size: 1.4rem;
  color: #9495a5;

  span {
    color: rgb(224, 125, 125);
  }
}

ul {
  display: flex;
  width: 16.6rem;

  li {
    cursor: pointer;
    font-weight: 700;

    &:hover {
      color: #494c6b;
    }
  }

  li:not(:first-child) {
    margin-left: 2rem;
  }
}

.clear-complete {
  cursor: pointer;

  &:hover {
    color: #494c6b;
  }
}

.dark-mode {
  &:hover {
    color: #fff;
  }
}

.filterBy {
  color: #3a7cfd;
}

ul.res-big {
  @media only screen and (max-width: 600px) {
    display: none;
  }
}

ul.res-small {
  position: absolute;
  transform: translateY(2rem);
  background-color: #fff;
  width: 32rem;
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 8rem;
  font-size: 1.4rem;
  color: #9495a5;
  border-radius: 5px;

  @media only screen and (min-width: 600px) {
    display: none;
  }
}

ul.list-light {
  background-color: #ffff;
}

ul.list-dark {
  background-color: #25273d;
}
</style>
